import React from 'react'
import Icon from '@material-ui/core/Icon';

class ImagePreview extends React.PureComponent {
  render() {
    const {
      source,
      filename,
      showDelete,
      handleDelete,
    } = this.props
    return (
      <div className="mb-24">
        <img src={source} alt="Question" className="questionImage" style={{maxWidth: '100%'}} />

        {
          filename && (
            <div className="d-flex align-items-center">
              <div className="playerTime">File: {filename}</div>
              {
                showDelete && (
                  <div style={{cursor: 'pointer'}}>
                    <Icon onClick={handleDelete}>delete_forever</Icon>
                  </div>
                )
              }
            </div>
          )
        }
      </div>
    )
  }
}

export default ImagePreview



// WEBPACK FOOTER //
// ./src/js/components/Mui/ImagePreview.js